import { api_getPlateIDRecord } from "../API/ballsStat";
import { videoStore } from "../state/videoSlice";
import visualAngle from "../data/visualAngle.json";

export const ValueMap = {
  InningList: [
    "_",
    "第一局",
    "第二局",
    "第三局",
    "第四局",
    "第五局",
    "第六局",
    "第七局",
    "第八局",
    "第九局",
    "第十局",
  ],
  PCList: {
    壞球: "Ball",
    "好球(揮空)": "Strk-S",
    "好球(沒揮)": "Strk-C",
    界外: "Foul",
    擊進場內: "In-Play",
  },
  HTList: {
    滾地球: "GROUND",
    平擊球: "LINE",
    高飛球: "FLYB",
    內野飛球: "POPB",
  },
  PRList: {
    三振: "SO",
    四壞球: "BB",
    觸身球: "HBP",
    一壘安打: "1B",
    二壘安打: "2B",
    三壘安打: "3B",
    全壘打: "HR",
    飛球出局: "FO",
    滾地球出局: "GO",
    雙殺打: "DP",
    三殺打: "TP",
    失誤: "E",
    "犧飛(含失誤)": "SF",
    "犧觸(含失誤)": "SH",
    出局: "OUT",
  },
  OList: {
    無人出局: 0,
    一人出局: 1,
    二人出局: 2,
  },
  OBList: {
    得點圈有人: 0,
    1: 1,
    2: 2,
    3: 4,
  },
  HardTList: {
    強勁: "HARD",
    一般: "MED",
    軟弱: "SOFT",
  },
  BarrelList: {
    Barrels: "Barrels",
    "Solid Contact": "Solid_Contact",
    "Flares & Bumers": "Flares_Bumers",
    Topped: "Topped",
    "Hit Under": "Hit_Under",
    "Weak Contact": "Weak_Contact",
  },
  ZPointList: {
    內角球: "Right",
    中間球: "H_Med",
    外角球: "Left",
    高球: "High",
    中球: "V_Med",
    低球: "Low",
  },
  TagPList: {
    四縫FB: "FB",
    伸卡FT: "FT",
    快速指叉SFF: "SFF",
    滑球SL: "SL",
    曲球CB: "CB",
    卡特CT: "CT",
    變速CH: "CH",
    指叉SP: "SP",
    慢速曲球SC: "SC",
    蝴蝶KN: "KN",
    其他OT: "OT",
  },
};

export const TaggedPitchTypeLabelMap = {
  all: "全部",
  FB: "四縫",
  FT: "伸卡",
  CT: "卡特",
  SL: "滑球",
  CB: "曲球",
  SC: "慢速曲球",
  CH: "變速球",
  SP: "指叉球",
  SFF: "快速指叉",
  OT: "其他",
  UN: "未知",
  KN: "蝴蝶球",
  "?": "?",
  "": "N/A",
  null: "IBB",
  ALFB: "直球",
};

export const wrapFilterRequestData = (formData) => {
  // console.log(formData)
  const specialValues = {
    OUT: [
      "G",
      "G-",
      "GT",
      "F",
      "SH",
      "SF",
      "IF",
      "INT",
      "LO",
      "OT-PO",
      "UN-IO",
      "DP",
      "TP",
      "K",
      "Ks",
      "K-SF",
      "K-DO",
      "K-DS",
      "K-BF",
      "K-BS",
      "FOT",
    ],
    FO: ["F", "IF", "SF"],
    GO: ["G", "G-", "GT", "SH", "DP", "TP"],
    HR: ["HR", "IHR"],
    E: ["E-C", "E-T", "E-SF", "E-SHC", "E-SHT"],
    SF: ["SF", "E-SF"],
    SH: ["SH", "E-SHT", "E-SHC", "FSH"],
    BB: ["BB", "BB-I", "BB-IL"],
    SO: ["K", "Ks", "K-SF", "K-DO", "K-BF", "K-DS", "K-BS"],
  };
  if (
    formData["APP_VeloRel_Min"] === formData["APP_VeloRel_Max"] &&
    formData["APP_VeloRel_Max"] === 80
  ) {
    formData["APP_VeloRel_Max"] = false;
    formData["APP_VeloRel_Min"] = false;
  }
  if (
    formData["ExitVelo_Min"] === formData["ExitVelo_Max"] &&
    formData["ExitVelo_Max"] === 0
  ) {
    formData["ExitVelo_Min"] = false;
    formData["ExitVelo_Max"] = false;
  }
  if (
    formData["ExitAngle_Min"] === formData["ExitAngle_Max"] &&
    formData["ExitAngle_Max"] === -90
  ) {
    formData["ExitAngle_Max"] = false;
    formData["ExitAngle_Min"] = false;
  }

  if (formData["APP_VeloRel_Min"] > formData["APP_VeloRel_Max"]) {
    let tmp = formData["APP_VeloRel_Min"];
    formData["APP_VeloRel_Min"] = formData["APP_VeloRel_Max"];
    formData["APP_VeloRel_Max"] = tmp;
  }
  if (formData["ExitVelo_Min"] > formData["ExitVelo_Max"]) {
    let tmp = formData["ExitVelo_Min"];
    formData["ExitVelo_Min"] = formData["ExitVelo_Max"];
    formData["ExitVelo_Max"] = tmp;
  }
  if (formData["ExitAngle_Min"] > formData["ExitAngle_Max"]) {
    let tmp = formData["ExitAngle_Max"];
    formData["ExitAngle_Max"] = formData["ExitAngle_Min"];
    formData["ExitAngle_Min"] = tmp;
  }

  let output = {};
  for (const key in formData) {
    if (
      !formData[key] ||
      (Array.isArray(formData[key]) && formData[key][0] === undefined)
    )
      continue;
    if (key === "BatSList" || key === "PTList" || key === "ZBList") {
      output[key] = [...formData[key]];
    } else if (key === "PCList") {
      output[key] = formData[key]
        .filter((e) => e !== "所有揮擊")
        .map((e) => ValueMap[key][e]);
    } else if (key === "HTList") {
      output[key] = formData[key]
        .filter((e) => e !== "所有飛球")
        .map((e) => ValueMap[key][e]);
    } else if (key === "PRList") {
      let init = [];
      for (const val of formData[key]) {
        if (specialValues[ValueMap[key][val]] !== undefined) {
          init = [...init, ...specialValues[ValueMap[key][val]]];
        } else {
          if (val === "安打") continue;
          init.push(ValueMap[key][val]);
        }
      }
      let initSet = new Set(init);
      let arr = Array.from(initSet);
      output[key] = arr;
    } else if (key === "Hardness") {
      let tags = [],
        barrel = [];
      for (let tag of formData[key]) {
        if (tag === "強勁" || tag === "一般" || tag === "軟弱") {
          tags.push(ValueMap["HardTList"][tag]);
        } else {
          barrel.push(ValueMap["BarrelList"][tag]);
        }
      }
      output["BarrelList"] = barrel;
      output["HardTList"] = tags;
    } else if (key === "BSList") {
      output[key] = formData[key].filter(
        (e) => !["投手領先", "打者領先", "平手"].includes(e),
      );
    } else if (key === "OBList") {
      let operation = "";
      if (formData[key].includes("壘上無人")) {
        if (formData[key].length !== 1) operation = ">8";
        else operation = "=0";
      } else {
        if (formData[key].includes("得點圈有人")) {
          if (formData[key].includes(1) && formData[key].length === 2) {
            operation = ">8";
          } else if (formData[key].length === 1) {
            operation = ">1";
          } else {
            let sum = 0;
            for (let n of formData[key]) sum += ValueMap["OBList"][n];
            operation = `=${sum}`;
          }
        } else {
          let sum = 0;
          for (let n of formData[key]) sum += ValueMap["OBList"][n];
          operation = `=${sum}`;
        }
      }
      output[key] = operation;
    } else if (key === "Bteam") {
      if (
        [
          "中信兄弟",
          "富邦悍將",
          "統一7-ELEVEn獅",
          "樂天桃猿",
          "味全龍",
          "台鋼雄鷹",
        ].includes(formData[key])
      )
        output.BatterTeam = formData[key];
    } else if (key === "Pteam") {
      if (
        [
          "中信兄弟",
          "富邦悍將",
          "統一7-ELEVEn獅",
          "樂天桃猿",
          "味全龍",
          "台鋼雄鷹",
        ].includes(formData[key])
      )
        output.PitcherTeam = formData[key];
    } else {
      if (Array.isArray(formData[key])) {
        output[key] = [];
        for (let val of formData[key]) {
          output[key].push(ValueMap[key][val]);
        }
      } else {
        output[key] =
          ValueMap[key] === undefined
            ? formData[key]
            : ValueMap[key][formData[key]];
      }
    }
  }
  if (output.PitcherObj) {
    // output.pid = PlayerNameIDMap[output.Pitcher]
    output.Pitcher = output.PitcherObj.label;
    output.pid = output.PitcherObj.id;
  }
  if (output.BatterObj) {
    // output.bid = PlayerNameIDMap[output.Batter]
    output.Batter = output.BatterObj.label;
    output.bid = output.BatterObj.id;
  }
  if (output.CatcherObj) {
    // output.cid = PlayerNameIDMap[output.Catcher]
    output.Catcher = output.CatcherObj.label;
    output.cid = output.CatcherObj.id;
  }
  output.League = "J61qWKmDQnVG3VoARPPgm4hAWuaCai0";
  // console.log(output)
  return output;
};

const map = new Map();
const onBaseMap = new Map();
onBaseMap.set(0, [false, false, false]);
onBaseMap.set(1, [true, false, false]);
onBaseMap.set(2, [false, false, true]);
onBaseMap.set(3, [true, false, true]);
onBaseMap.set(4, [false, true, false]);
onBaseMap.set(5, [true, true, false]);
onBaseMap.set(6, [false, true, true]);
onBaseMap.set(7, [true, true, true]);

export const resolveVideoData = async (videoData) => {
  if (!map.has(videoData.plate_id)) {
    const { data } = await api_getPlateIDRecord({
      plate_id: videoData.plate_id,
    });
    map.set(videoData.plate_id, data);
  }

  let GameInfoData = undefined;

  for (let i of map.get(videoData.plate_id)) {
    if (i.VideoTimePart === videoData.VideoTimePart) {
      GameInfoData = i;
      break;
    }
  }

  // get view of state...
  const view = videoStore.getState().view || videoData.view;

  return {
    plate_id: videoData.plate_id,
    view: view,
    onBase: GameInfoData["On-Base"]
      ? onBaseMap.get(GameInfoData["On-Base"])
      : onBaseMap.get(0),
    title: videoData.title,
    year: videoData.year,
    date: GameInfoData.Date || "",
    team1: GameInfoData.PitcherTeam || "",
    team2: GameInfoData.BatterTeam || "",
    hitter: videoData.hitter,
    hitter_number: videoData.hitter_number,
    hitterhand: videoData.hitterhand,
    pitcher: videoData.pitcher,
    pitcher_number: videoData.pitcher_number,
    pitcherhand: videoData.pitcherhand,
    details: videoData.details,
    length: videoData.length,
    Umpire: GameInfoData.Umpire || "",
    src: visualAngle[view],
    video_object_key: `${GameInfoData.plate_id}_${GameInfoData.Pitch_ID}.mp4`,
    stat_no: `${ValueMap.InningList[GameInfoData.Inning]}${GameInfoData["Top/Bottom"] === "Top" ? "上" : "下"} `,
    stat_info: `${GameInfoData.BS}, ${GameInfoData.Outs} OUT`,
    pitching_type: videoData.pitching_type,
    pitching_speed: videoData.pitching_speed,
    pitching_results: videoData.pitching_results,
    batting_results: videoData.batting_results,
    batting_type: videoData.batting_type,
    batting_speed: videoData.batting_speed,
    batting_angle: videoData.batting_angle,
    pitcher_xy: { x: GameInfoData.APP_KZoneY, y: GameInfoData.APP_KZoneZ }, // 入球點示意圖座標
    batter_xy: { x: GameInfoData.LocX, y: GameInfoData.LocY }, // 落球點示意圖座標
  };
};

export const resolveFilmroomPlateData = (
  filmData,
  pitcherNumMap,
  batterNumMap,
) => {
  return {
    plate_id: filmData.plate_id,
    VideoTimePart: filmData.VideoTimePart,
    view: "轉播視角",
    onBase: onBaseMap.get(0),
    title: [
      filmData.Batter,
      getKeyByValue(ValueMap.TagPList, filmData.TaggedPitchType),
      getKeyByValue(ValueMap.PCList, filmData.PitchCode),
      getKeyByValue(ValueMap.PRList, filmData.PA_Result),
    ].join(" "),
    year: filmData.Year || "",
    date: "",
    team1: "",
    team2: "",
    hitter: filmData.Batter || "",
    hitter_number: batterNumMap.get(filmData.Batter) || "",
    hitterhand: "R",
    pitcher: filmData.Pitcher || "",
    pitcher_number: pitcherNumMap.get(filmData.Pitcher) || "",
    pitcherhand: "L",
    details: [
      ValueMap.InningList[filmData.Inning],
      getKeyByValue(ValueMap.TagPList, filmData.TaggedPitchType),
      getKeyByValue(ValueMap.PCList, filmData.PitchCode),
      getKeyByValue(ValueMap.PRList, filmData.PA_Result),
    ].join(" "),
    length: filmData.VideoTimePart || "",
    Umpire: "",
    src: "",
    stat_no: "",
    stat_info: "",
    pitching_type:
      getKeyByValue(ValueMap.TagPList, filmData.TaggedPitchType) || "",
    pitching_speed: (filmData.APP_VeloRel || "?") + "km",
    pitching_results: getKeyByValue(ValueMap.PCList, filmData.PitchCode) || "",
    batting_results: getKeyByValue(ValueMap.PRList, filmData.PA_Result) || "",
    batting_type: [
      getKeyByValue(ValueMap.HTList, filmData.HitType),
      getKeyByValue(ValueMap.HardTList, filmData.HardnessTag),
    ].join(" "),
    batting_speed: (filmData.BatS || "?") + "km",
    batting_angle: (Math.round(filmData.Theta * 100) / 100 || "?") + "度",
  };
};

function getKeyByValue(map, value) {
  return Object.keys(map).find((key) => map[key] === value);
}
